import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import css from "./footer.module.scss";
import PolicyModal from "../modals/PolicyModal";

const Footer = () => {
    const [openPrivacy, setOpenPrivacy] = useState(false);
    const [openCookies, setOpenCookies] = useState(false);

    useEffect(() => {
        const openCookieModal = () => setOpenCookies(true);
        window.addEventListener("open-cookie-modal", openCookieModal as EventListener);
        return () => window.removeEventListener("open-cookie-modal", openCookieModal as EventListener);
    }, []);

    const year = new Date().getFullYear();

    return (
        <footer className={css.footer}>
            <div className={css.inner}>
                <div className={css.brand}>
                    <h3 className={css.title}>BolleNoord 't Zand B.V.</h3>
                    <p className={css.muted}>Professionele verwerking, opslag en exportvoorbereiding van bloembollen in 't Zand, Noord-Holland.</p>
                    <div className={css.badgeRow}>
                        <span className={css.badge}>Betrouwbaar</span>
                        <span className={css.badge}>Efficiënt</span>
                        <span className={css.badge}>Deskundig</span>
                    </div>
                </div>

                <div>
                    <h4 className={css.sectionTitle}>Navigatie</h4>
                    <div className={css.links}>
                        <Link to="/">Home</Link>
                        <Link to="/galerij">Galerij</Link>
                        <Link to="/contact">Contact</Link>
                    </div>
                </div>

                <div>
                    <h4 className={css.sectionTitle}>Contact</h4>
                    <div className={css.links}>
                        <a href="tel:+31224590404">+31 224 590404</a>
                        <a href="mailto:info@bollenoord.com">info@bollenoord.com</a>
                        <span className={css.muted}>Groteweg 9, 1756 CK 't Zand</span>
                    </div>
                </div>

                <div>
                    <h4 className={css.sectionTitle}>Juridisch</h4>
                    <div className={css.links}>
                        <button onClick={() => setOpenPrivacy(true)}>Privacyverklaring</button>
                        <button onClick={() => setOpenCookies(true)}>Cookieverklaring</button>
                    </div>
                </div>
            </div>

            <div className={css.bottom}>
                <div className={css.credit}>
                    &copy; {year} BolleNoord 't Zand B.V. Alle rechten voorbehouden.
                </div>
                <div className={css.credit}>
                    Website ontwikkeld door <a href="https://www.kodin.nl" target="_blank" rel="noreferrer">Kodin</a>
                </div>
            </div>

            <PolicyModal title="Privacyverklaring" open={openPrivacy} onClose={() => setOpenPrivacy(false)}>
                <p>Wij hechten grote waarde aan uw privacy. In deze privacyverklaring leggen wij uit welke persoonsgegevens wij verzamelen, waarom wij dat doen en hoe wij uw gegevens beveiligen.</p>
                <h3>Welke gegevens verwerken wij?</h3>
                <p>Wanneer u ons contactformulier gebruikt of ons belt/mailt, verwerken wij de door u verstrekte gegevens, zoals naam, e-mailadres, telefoonnummer en uw bericht.</p>
                <h3>Doeleinden</h3>
                <ul>
                    <li>Om uw vraag of verzoek te kunnen beantwoorden;</li>
                    <li>Om onze dienstverlening uit te voeren en te verbeteren;</li>
                    <li>Om aan wettelijke verplichtingen te voldoen.</li>
                </ul>
                <h3>Bewaartermijn</h3>
                <p>Wij bewaren uw gegevens niet langer dan noodzakelijk voor de doeleinden waarvoor ze zijn verkregen, tenzij wij wettelijk verplicht zijn gegevens langer te bewaren.</p>
                <h3>Delen met derden</h3>
                <p>Wij delen uw gegevens niet met derden, tenzij dit noodzakelijk is voor de uitvoering van onze overeenkomst of om te voldoen aan een wettelijke plicht.</p>
                <h3>Uw rechten</h3>
                <p>U heeft het recht op inzage, correctie en verwijdering van uw persoonsgegevens. Neem hiervoor contact met ons op via <a href="mailto:info@bollenoord.com">info@bollenoord.com</a> of <a href="tel:+31224590404">+31 224 590404</a>.</p>
                <h3>Beveiliging</h3>
                <p>Wij nemen passende technische en organisatorische maatregelen om uw gegevens te beschermen.</p>
                <h3>Contact</h3>
                <p>BolleNoord 't Zand B.V., Groteweg 9, 1756 CK 't Zand. E-mail: <a href="mailto:info@bollenoord.com">info@bollenoord.com</a>.</p>
            </PolicyModal>

            <PolicyModal title="Cookieverklaring" open={openCookies} onClose={() => setOpenCookies(false)}>
                <p>Deze website maakt gebruik van cookies. Wij gebruiken uitsluitend functionele cookies die nodig zijn om de website goed te laten werken en om uw voorkeuren (zoals cookiekeuze) te onthouden.</p>
                <h3>Wat zijn cookies?</h3>
                <p>Cookies zijn kleine tekstbestanden die bij uw bezoek aan onze website op uw apparaat worden geplaatst.</p>
                <h3>Welke cookies gebruiken wij?</h3>
                <ul>
                    <li>Functionele cookies: noodzakelijk voor het goed functioneren van de site.</li>
                    <li>Voorkeurscookies: om uw cookievoorkeur (geaccepteerd/geweigerd) te onthouden.</li>
                </ul>
                <h3>Analytics</h3>
                <p>Wij gebruiken momenteel geen analytische of marketingcookies.</p>
                <h3>Beheer van cookies</h3>
                <p>U kunt uw cookievoorkeuren wijzigen via de cookiebanner of door uw browserinstellingen aan te passen. Neem bij vragen contact op via <a href="mailto:info@bollenoord.com">info@bollenoord.com</a>.</p>
            </PolicyModal>
        </footer>
    )
}

export default Footer;